"use client";

import React, { type PropsWithChildren } from "react";

import { useMediaQuery } from "@/hooks/useMediaQuery";

import MobileLayoutBar from "@/components/MobileLayout/Bar";
import LayoutAlertBarWrapper from "@/components/Layout/AlertBar/Wrapper";
import LayoutAlertBarUsRestriction from "@/components/Layout/AlertBar/UsRestriction";
import LayoutHeader from "@/components/Layout/Header";
import LayoutSidebarRight from "@/components/Layout/Sidebar/Right";
import { SupDialogBodyLocker } from "@repo/core-ui";

export default function Layout({ children }: PropsWithChildren) {
  const isMobile = useMediaQuery("(max-width: 767px)");

  return (
    <SupDialogBodyLocker>
      <main className="h-screen justify-stretch overflow-hidden bg-neutral pb-12 md:flex md:w-full md:max-w-[100vw] md:items-stretch md:pb-0 md:pt-14">
        {!isMobile && <LayoutHeader />}
        <section className="custom-scrollbar relative flex h-full w-full min-w-full max-w-full flex-col overflow-y-auto overflow-x-hidden md:mx-auto md:h-auto md:min-h-0 md:flex-1 md:grow md:items-stretch md:justify-stretch">
          <LayoutAlertBarWrapper />
          <LayoutAlertBarUsRestriction />
          {children}
        </section>
        {!isMobile && <LayoutSidebarRight />}
      </main>
      {isMobile && <MobileLayoutBar />}
    </SupDialogBodyLocker>
  );
}
